import styles from "./m3.module.css";

/**
 * Outlined card that groups related form fields under a title.
 *
 * @param {string} title
 * @param {string} description - one line explaining the group
 * @param {React.ReactNode} icon
 * @param {React.ReactNode} action - element at the top-right (e.g. a delete button)
 */
export const FormSection = ({ title, description, icon, action, children, className = "" }) => (
  <section className={`${styles.section} ${className}`}>
    {(title || action) && (
      <div className={styles.sectionHead}>
        {icon && <span className={styles.sectionIcon}>{icon}</span>}
        <div className={styles.sectionTitles}>
          {title && <h3 className={styles.sectionTitle}>{title}</h3>}
          {description && <p className={styles.sectionDesc}>{description}</p>}
        </div>
        {action && <div className={styles.sectionAction}>{action}</div>}
      </div>
    )}
    {children}
  </section>
);

/**
 * Responsive field grid. Collapses to one column on narrow screens.
 * Children may use the `span` prop on M3Field (2 or "all") to widen.
 */
export const FieldGrid = ({ columns = 2, children }) => (
  <div className={styles.fieldGrid} style={{ "--cols": columns }}>
    {children}
  </div>
);

export default FormSection;
